import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import ContentSection from '../components/ContentSection';
import Footer from '../components/Footer';
import '../styles/App.css';

function Support() {
  const supportContent = {
    sectionTitle: (
      <>
        Need <span style={{ color: 'red' }}>Help?</span>
      </>
    ),
    sectionDescription:
      'We\'re here to help you get the most out of Begin Strength. If you\'re experiencing issues or have questions, reach out to our support team.',
    items: [
      {
        title: 'Having Issues?',
        body1: (
          <>
            <p>
              If you're experiencing technical issues, have questions about your account, or need help with the app, our support team is ready to assist you.
            </p>
            <p>
              <strong>Email us at:</strong>{' '}
              <a 
                href="mailto:sam+appsupport@beginthework.com" 
                style={{ color: 'red', textDecoration: 'none' }}
              >
                sam+appsupport@beginthework.com
              </a>
            </p>
            <p>
              We typically respond within 24-48 hours during business days.
            </p>
          </>
        ),
      },
      {
        title: 'Common Questions',
        body1: (
          <>
            <p>
              Before reaching out, you might find answers to common questions in our{' '}
              <a href="/faqs" style={{ color: 'red', textDecoration: 'none' }}>
                FAQ section
              </a>.
            </p>
            <p>
              For account-related questions, program setup, or feature requests, please use the email above.
            </p>
          </>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <SEO
        title="Support"
        description="Get help with Begin Strength. Contact our support team for technical issues, account questions, or app assistance."
        image="/social-media-image.png"
        path="/support"
      />
      <Header />
      <main>
        <ContentSection
          sectionTitle={supportContent.sectionTitle}
          sectionDescription={supportContent.sectionDescription}
          items={supportContent.items}
          sectionClass="faq-sub-section"
          showNumbers={false}
        />
        <Footer />
      </main>
    </div>
  );
}

export default Support;
